import { ISelectCardFormData } from '../types/ISelectCardFormData';
import { useTokenizedCards } from './useTokenizedCards';

export const useSelectCardFormDefaultValues = ():
	| ISelectCardFormData
	| undefined => {
	const { cards } = useTokenizedCards();
	return cards.length === 1 ? { tokenizedCardId: cards[0].id } : undefined;
};
